import { LocationData } from '../../types';

export default function handleSubmit(
  fn: (zip: string) => Promise<LocationData>,
  value: string,
  onSubmitCallback: ({ zip }: { zip: string }) => void,
  closeHandler: () => void
) {
  return (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    fn(value)
      .then(onSubmitCallback)
      .then(closeHandler)
      .catch(() => {});
  };
}
